
import * as Sentry from '@sentry/vue'

import { setAuthToken } from '@/helpers/authToken'

export default {
  metaInfo: {
    title: 'Auth'
  },
  data() {
    return {
      message: 'Authenticating...',
      token: this.$route.query.token
    }
  },
  computed: {},
  async mounted() {
    Sentry.captureMessage('Auth.vue accessed')
    if (this.token && this.token.length) {
      setAuthToken(this.token)
      await this.$store.dispatch('getLoggedInUser').catch(() => {})
      this.$router.push('/')
    } else {
      this.message = 'Error authenticating. <a href="/login">Login</a>'
    }
  },
  methods: {}
}
